import { EventItemEntity } from "src/app/core/entities/service-book/event-item";
import { GetEventItemFormResponse } from "src/app/core/output-data/get-event-item-form.response";

export class EventItemFormViewModel {
   GetEventItemFormResponse: GetEventItemFormResponse;
   NewId: string;
}